export default class y{constructor(){}Ts(a){}changeUser(a=!1){}clearData(a=!1){}}